<app-page-meta pageTitle="finzy - Log in for the finzy experience"
	tags="finzy, peer to peer lending, peer to peer lending india, line of credit online, easy finance, need a loan, india credit finance, personal loans, easy loans, loan, loan india, current loan rates india, best loans india, best loan rates, cheapest loans india, high investment investment opportunities, investments, quick personal loans, low interest personal loans"
	description="finzy ensures that you have secure access to you borrowing or lending account via a phone OTP.">
</app-page-meta>

<app-header *ngIf="finzyDomain"></app-header>
<app-theader *ngIf="otherDomain"></app-theader>

<ng-container *ngIf="!profile_id">
	<div class="row mainrow">
		<div class="col-sm-2"></div>
		<div class="col-sm-8 rightdiv">
			<div class="rightinnerdiv">
				<form #d="ngForm" (ngSubmit)="submitOtpLogin(d.value)" (keydown.enter)="$event.preventDefault()">
					<p class="headtxt">Login using OTP</p>

					<p class="txt1">Your registered mobile number or PAN</p>

					<mat-form-field style="width: 100%">
						<span matPrefix></span>
						<input style="text-transform: uppercase" matInput placeholder="Enter your Login ID"
							maxlength="10" [(ngModel)]="loginId" name="loginId" type="text" required autocomplete="off"
							[readonly]="isReadonly">
						<button mat-stroked-button matSuffix class="btn-input-suffix" (click)="sendOtp()"
							[disabled]="fieldDisabledTag">{{otpButton}}</button>
					</mat-form-field>
					<span class="errormsg" *ngIf="mobileError">{{mobileErrorMsg}}</span>
					<span class="informational">{{ otpSentText }}</span>

					<p class="txt1">Enter OTP number</p>

					<mat-form-field style="width: 100%">
						<input matInput placeholder="Please enter the OTP you have received" autocomplete="off"
							[(ngModel)]="otp" name="otp" required type="password" maxlength="6"
							[disabled]="otpDisabled">
					</mat-form-field>
					<span class="errormsg" *ngIf="otpError">{{otpErrorMsg}}</span>

					<app-primary-button class="mt-5" [isLoading]="loaderStatus.isLoading">LOGIN</app-primary-button>
				</form>

			</div>
		</div>
		<div class="col-sm-2"></div>
	</div>
</ng-container>

<ng-container *ngIf="profile_id">
	<mat-spinner class="spinner" [diameter]="35"></mat-spinner>
</ng-container>

<app-footer *ngIf="finzyDomain"></app-footer>
<app-tfooter *ngIf="otherDomain"></app-tfooter>